
import Vue from "vue";
import { RoadmapService } from "@/services/roadmap-service";
import { Roadmap } from "@/models/roadmap";
import { ToolbarService } from "@/services/toolbar-service";

export default Vue.extend({
	data() {
		return {
			loaded: false,
			roadmap: new Roadmap(),
		};
	},
	computed: {

	},
	methods: {},
	async mounted() {
		this.loaded = true;
		ToolbarService.title = this.$ct("title");
		this.roadmap = await RoadmapService.getItem(parseInt(this.$route.params.id));
	},
	components: {},
	i18nEx: {
		componentPrefix: "views.SupportRoute.RoadmapDefault"
	}
});
